import React, { useState, useEffect } from "react";
import { Formik, Form, FieldArray, Field } from "formik";
import { MdOutlineRemoveCircle } from "react-icons/md";
import { useNavigate, Link } from "react-router-dom";
import {getAuthorization} from "../../../axios/AxiosAut";
import Itemsdata from "./table/Itemsdata";
import Pickitemsdata from "./table/Pickitemsdata";
import UserForm from "./UserForm";
import GroupForm from "./GroupForm";
import Swal from "sweetalert2"

function ScheduleJob() {
  const [status, setStatus] = useState(1); // 0: no show, 1: show yes, 2: show no.

  const radioHandler = (status) => {
    setStatus(status);
  };
 
  const Navigate = useNavigate();

  // User scheduler form
  const UserInitialValues = {
    name: "",
    assigned_to: "staff",
    type: "",
    start_date: "",
    end_date: "",
    start_time: "",
    end_time: "",
    staff:{
      id: ""
    },
    customer: ""
    // contacts:[]
  };
  const UserOnSubmit = (values, onSubmitProps) => {
    console.log("User values", values)
    getAuthorization()
    .post("company/create_schedules/", values)
    .then((res) => {
      Swal.fire({
        position: "top-end",
        title: "Schedule Created!",
        showConfirmButton: false,
        timer: 3500,
        showClass: {
          popup: "animate__animated animate__fadeInRight",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutRight",
        },
        width: 300,
        color: "#FFFFFF",
        background: "#2A91D7",
        backdrop: `rgba(0,0,0,0)`,
      });
      Navigate("/dashboard/management/scheduler-dashboard")
    })
    .catch((err) => {
      console.log("Error in creating schedule", err);
      onSubmitProps.setSubmitting(false);
    });

  };

 // Group scheduler form
 const GroupInitialValues = {
  name: "",
  assigned_to: "group",
  type: "",
  start_date: "",
  end_date: "",
  start_time: "",
  end_time: "",
  group:{
    id: ""
  },
  customer: ""
  // contacts:[]
};
const GroupOnSubmit = (values, onSubmitProps) => {
  console.log("Group values", values)
  getAuthorization()
    .post("company/create_schedules/", values)
    .then((res) => {
      Swal.fire({
        position: "top-end",
        title: "Schedule Created!",
        showConfirmButton: false,
        timer: 3500,
        showClass: {
          popup: "animate__animated animate__fadeInRight",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutRight",
        },
        width: 300,
        color: "#FFFFFF",
        background: "#2A91D7",
        backdrop: `rgba(0,0,0,0)`,
      });
      Navigate("/dashboard/management/scheduler-dashboard")
    })
    .catch((err) => {
      console.log("Error in creating schedule", err);
      onSubmitProps.setSubmitting(false);
    });
};
  
  return (
    <>
      <main className="max-w-full  py-4">
        <div className="flex flex-col justify-items-center ml-8">
          <h2 className="font-Montserrat text-xl font-bold text-black">
            Scheduling
          </h2>
          <div className="border-b-2 border-blue-200 w-20"></div>

          <div className="inline-flex float-left mt-4 ml-5">
            <div className="form-check form-check-inline">
              <input
                className=" form-check-input appearance-none rounded-full h-4 w-4 border border-gray-300 bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                type="radio"
                name="inlineRadioOptions"
                id="inlineRadio1"
                value="option1"
                checked={status === 1}
                onClick={(e) => radioHandler(1)}
              />
              <label
                className="form-check-label inline-block ml-1 mr-4 text-gray-800"
                // for="inlineRadio10"
              >
                User
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className=" form-check-input ml-10 appearance-none rounded-full h-4 w-4 border border-gray-300 bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                type="radio"
                name="inlineRadioOptions"
                id="inlineRadio2"
                value="option2"
                checked={status === 2}
                onClick={(e) => radioHandler(2)}
              />
              <label
                className="form-check-label inline-block text-gray-800 ml-1
            mr-4"
                // for="inlineRadio20"
              >
                Group
              </label>
            </div>
          </div>
          <div className="">
            {status === 1 && (
              <div className=" mt-8">
          <div className="flex flex-col justify-items-center">
            <Formik
              initialValues={UserInitialValues}
              onSubmit={UserOnSubmit}
              //   validationSchema={validationSchema}
              //   validateOnMount
            >
              <Form>
                <UserForm/>
                <div className="flex flex-row justify-center space-x-128 my-10">
                    <button
                      type="button"
                      className="text-red-600 font-Montserrat font-medium text-lg"
                      onClick={() => Navigate("/dashboard/management/scheduler-dashboard")}
                    >
                      Go Back
                    </button>
                    <Field>
                      {(props) => {
                        const { field, form, meta } = props;
                        const { isSubmitting } = form;
                        return (
                          <>
                            {!isSubmitting ? (
                              <button
                                type="submit"
                                {...(form.isValid
                                  ? {
                                      className:
                                        "font-Montserrat font-semibold text-white flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow",
                                    }
                                  : {
                                      disabled: true,
                                      className:
                                        "font-Montserrat font-semibold text-white flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow opacity-50 cursor-not-allowed",
                                    })}
                              >
                                Save Schedule
                              </button>
                            ) : (
                              <button
                                disabled
                                className="font-Montserrat font-semibold text-white flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow "
                              >
                                <div className="flex items-center justify-center space-x-2 animate-pulse">
                                  <svg className="w-5 h-5 bg-green-50 rounded-full"></svg>
                                  <svg className="w-5 h-5 bg-green-50  rounded-full"></svg>
                                  <svg className="w-5 h-5 bg-green-50  rounded-full"></svg>
                                </div>
                              </button>
                            )}
                          </>
                        );
                      }}
                    </Field>
                 </div>
              </Form>
            </Formik>
      </div>
              </div>
            )}
            {status === 2 && (
              <div className="mt-8">
                <div className="flex flex-col justify-items-center">
            <Formik
              initialValues={GroupInitialValues}
              onSubmit={GroupOnSubmit}
              //   validationSchema={validationSchema}
              //   validateOnMount
            >
              <Form>
                <GroupForm/>
              <div className="flex flex-row justify-center space-x-128 my-10">
          <button
            type="button"
            className="text-red-600 font-Montserrat font-medium text-lg"
            onClick={() => Navigate("/dashboard/management/customer-dashboard")}
          >
            Go Back
          </button>
          <Field>
            {(props) => {
              const { field, form, meta } = props;
              const { isSubmitting } = form;
              return (
                <>
                  {!isSubmitting ? (
                    <button
                      type="submit"
                      {...(form.isValid
                        ? {
                            className:
                              "font-Montserrat font-semibold text-white flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow",
                          }
                        : {
                            disabled: true,
                            className:
                              "font-Montserrat font-semibold text-white flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow opacity-50 cursor-not-allowed",
                          })}
                    >
                      Save Schedule
                    </button>
                  ) : (
                    <button
                      disabled
                      className="font-Montserrat font-semibold text-white flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow "
                    >
                      <div className="flex items-center justify-center space-x-2 animate-pulse">
                        <svg className="w-5 h-5 bg-green-50 rounded-full"></svg>
                        <svg className="w-5 h-5 bg-green-50  rounded-full"></svg>
                        <svg className="w-5 h-5 bg-green-50  rounded-full"></svg>
                      </div>
                    </button>
                  )}
                </>
              );
            }}
          </Field>
         </div>
              </Form>
            </Formik>
         </div>
              </div>
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default ScheduleJob;
